import { Controller } from "@hotwired/stimulus";
import { debugLog } from "../utils";

export default class extends Controller {
    static targets = ["noteForm", "noteInput", "charCounter", "error"];

    connect() {
        debugLog("ActivityDetailsController: Connected");
        this.autosaveDisabled = false;
        if (this.hasCharCounterTarget) {
            this.charCounterTarget.classList.add("hidden");
        }

        this.initialValue = this.hasNoteInputTarget ? this.noteInputTarget.value.trim() : "";
    }

    submitNote() {
        if (!this.hasNoteInputTarget || !this.hasNoteFormTarget) {
            return;
        }

        const currentValue = this.noteInputTarget.value.trim();

        if (this.autosaveDisabled) {
            debugLog("Autosave disabled due to validation error");
            return;
        }

        if (currentValue === this.initialValue) {
            debugLog("No changes detected, skipping submit");
            return;
        }

        this.noteFormTarget.requestSubmit();
        this.initialValue = currentValue;
    }

    updateCounter() {
        if (!this.hasNoteInputTarget) {
            return;
        }

        const max = 200;
        const length = this.noteInputTarget.value.length;

        if (this.hasCharCounterTarget) {
            const counter = this.charCounterTarget;
            counter.textContent = `${length}/${max}`;
            counter.classList.toggle("hidden", length <= 175);
            counter.classList.toggle("text-red-600", max - length <= 20);
        }

        const overLimit = length >= max;
        if (this.hasErrorTarget) {
            this.errorTarget.classList.toggle("hidden", !overLimit);
        }
        this.autosaveDisabled = overLimit;
    }
}
